import { render } from "./LineStylePanel.vue?vue&type=template&id=65b24fb3&scoped=true&ts=true"
import script from "./LineStylePanel.vue?vue&type=script&lang=ts"
export * from "./LineStylePanel.vue?vue&type=script&lang=ts"

import "./LineStylePanel.vue?vue&type=style&index=0&id=65b24fb3&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b24fb3"]])

export default __exports__